import { render, staticRenderFns } from "./discordTech3.vue?vue&type=template&id=7a212c7b"
import script from "./discordTech3.vue?vue&type=script&lang=js"
export * from "./discordTech3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports